<template>
    <div id="divDashboardEstudiante" v-show="flagMostrarDashboard">
        <b-breadcrumb>
            <b-breadcrumb-item to="/dashboard" active>{{$t('dashboard.card-cursos.dashboard')}}</b-breadcrumb-item>
                <template>
                    <!-- <b-breadcrumb-item>Profesores</b-breadcrumb-item> -->
                </template>
        </b-breadcrumb>
            <b-alert v-if="showExpiryReminder" show variant="warning" class="mb-4">
                {{ lang == 'es'
                    ? 'Tu paquete vence el ' + (groupsPlan ? groupsPlan.strExpirationDate : '') + ' y aún tienes ' + remainingUnscheduledHours + ' hora(s) sin agendar. Por favor agéndalas antes de la fecha de vencimiento.'
                    : 'Your package expires on ' + (groupsPlan ? groupsPlan.strExpirationDate : '') + ' and you still have ' + remainingUnscheduledHours + ' unscheduled hour(s). Please schedule them before it expires.' }}
            </b-alert>
            <div class="english-level mb-5">
                <h6>{{$t('dashboard.nivel')}}:</h6>
                <div class="select-level">
                    <button v-for="item in levels" :key="item.id" :id="'level_'+item.id" :class="[item.flagLevels == true ? 'active' : null ,'gd-'+item.id]" >
                        <h1>{{item.abbreviation}}
                            <span>{{lang == "es" ? item.name: item.name_En}}</span>
                        </h1>
                    </button>
                </div>
            </div>

          
            <b-row class="mb-4"  v-if="groupsPlan != null && flag_subject">
                <b-col>
                    <div class="card card-body card-availability max-card justify-content-between" :class="[!(flagPlanPrueba && teacher || !flagPlanPrueba) ? 'min-card-2' : '', { 'rating-open': currentTeacherRatable }]">
                        <div>
                            <h6 class="sub-title text-left mb-4" :class="[!(flagPlanPrueba && teacher || !flagPlanPrueba) ? 'mb-4' : '']"><span>{{$t('dashboard.card-cursos.titulo')}}</span></h6>
                            <div class="d-flex mb-3 align-items-center pl-3">
                                <img src="@/assets/img/notes-3.png" class="flex-shrink-0 course-subjects-icon">
                                <div class="ml-4">
                                    <ul class="list-ul">
                                        <li v-for="item in subjects" :key="item.id" :id="'subject_'+item.id">{{ lang == "es" ? item.name : item.name_EN}}</li>
                                    </ul>
                                        <router-link v-if="!flagPlanPrueba && !groupsPlan.flagGroup" 
                                        class="link mt-3"
                                        to="/cursos" >
                                        <span>{{$t('dashboard.card-cursos.question')}}</span>
                                    </router-link>
                                    
                                </div>
                            </div>
                        </div>
                        <div v-if="flagPlanPrueba && teacher || !flagPlanPrueba">
                            <h6 class="sub-title text-left mt-3 mb-2">
                                <span v-if="teacher && availabilityClass">{{$t('dashboard.card-me-teacher.titulo')}}</span>
                                <span v-else>{{$t('dashboard.card-you-teacher.titulo')}}</span>
                            </h6>
                            <div class="mb-3 pl-3" v-if="teacher && teacher.person">
                                <div class="d-flex align-items-center">
                                    <b-avatar size="64px" class="flex-shrink-0" variant="light" :src="teacher.person.photo ? teacher.person.photo : urlPhoto.PHOTO_TEACHER_DEFAULT"></b-avatar>
                                    <div class="ml-4 teacher-info">
                                        <h6 class="sub-title text-left title-sub mb-0"><span>{{teacher.person.strFullName}}</span></h6>
                                        <div class="d-flex align-items-center">
                                            <button type="button" class="btn btn-primary mb-0" @click="$router.push('/chat')"><img src="@/assets/img/chatear.png" class="chat-icon">{{$t('dashboard.card-me-teacher.button')}}</button>
                                            <!-- Teacher's public rating badge: average (1 decimal) + published-review count -->
                                            <span v-if="!flagPlanPrueba && teacherRatingCount > 0" class="teacher-rating-badge ml-3">
                                                {{ teacherRatingAvg }} <span class="badge-star">★</span> <span class="badge-count">({{ teacherRatingCount }})</span>
                                            </span>
                                        </div>
                                        <a href="#" class="link" @click="getTeacherChanges" v-if="!flagPlanPrueba && ((groupsPlan.flagGroup && this.$store.state.is_representative) || !groupsPlan.flagGroup)"><span>{{$t('dashboard.card-me-teacher.question')}}</span></a>
                                    </div>
                                </div>
                                <!-- Inline rating panel shown by default when the student can rate (>=3 classes, not yet rated). No pop-up, no toggle. -->
                                <div v-if="!flagPlanPrueba && currentTeacherRatable" class="inline-rating w-100 mt-2 border-top pt-2">
                                    <div class="d-flex justify-content-between align-items-start">
                                        <label class="inline-rating-label mb-0">{{ lang == 'es' ? '¿Cómo calificarías a tu profesor(a)?' : 'How would you rate your teacher?' }}</label>
                                        <b-form-rating v-model="teacherRatingValue" stars="5" no-border size="sm" class="rating-gold flex-shrink-0"></b-form-rating>
                                    </div>
                                    <b-form-textarea v-model="teacherRatingComment" :placeholder="lang == 'es' ? 'Comentario (opcional)' : 'Comment (optional)'" rows="2" no-resize class="mt-2"></b-form-textarea>
                                    <small v-if="ratingError" class="text-danger d-block mt-1">{{ ratingError }}</small>
                                    <div class="mt-2">
                                        <b-button variant="primary" size="sm" class="btn-rating" :disabled="ratingLoading" @click="confirmPublishRating">{{$t('modals.score-teacher.btn-1')}}</b-button>
                                    </div>
                                </div>
                            </div>
                            <div v-else  class="d-flex mb-3 align-items-center pl-3" >
                                <img src="@/assets/img/Objetivo-5.png" alt="">
                                <div class="ml-4">
                                    <h6 class="d-flex align-items-center"><span class="spanSubTitle">{{$t('dashboard.card-you-teacher.text')}}</span></h6>
                                    <b-button variant="primary" class="mt-3" @click="$router.push({name:'horario'})"><icon name="calendar" class="mr-2" />{{$t('dashboard.card-you-teacher.button')}}</b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="card card-body card-availability max-card" :class="{ 'rating-open': currentTeacherRatable }" v-if="!flagPlanPrueba">
                        <h6 class="sub-title text-left mb-4"><span>{{$t('dashboard.card-plan.titulo')}}</span></h6>
                        <p class="mb-2">{{$t('dashboard.card-plan.text.1', {Days: groupsPlan.strDaysNumber})}}</p>
                        <p>{{$t('dashboard.card-plan.text.2')}} {{groupsPlan.strPurchaseExpirationDate}}</p>
                        <div class="mt-2" v-if="groupsPlanFreeze">
                            <label>{{$t('dashboard.card-plan.date-frozen', {Day: groupsPlanFreeze ? groupsPlanFreeze.endDateStr : ''})}}</label>
                        </div>
                        <div class="mt-2" v-if="groupsPlan.flagGroup">
                            <a @click="getGroupInformation" href="#" class="link mt-3"><span>{{$t('dashboard.card-plan.group-data')}}</span></a>
                        </div>
                        
                        <div id="circle-progress" class="d-flex justify-content-between mt-5 mb-4">
                            <Progress
                                :transitionDuration="5000" 
                                :radius="74"
                                :strokeWidth="15"
                                :value="groupsPlan.percentHoursCompleted" 
                            >
                            <div class="content d-flex justify-content-center">
                                <h6 class="sub-title text-center mb-0"><span>{{groupsPlan.totalHoursSchedule}}/{{groupsPlan.duration  }} <br> {{$t('reusables.hours')}}</span></h6>
                            </div>
                            </Progress>
                            <p class="justify-content-center w-100">
                                {{groupsPlan.differenceHours}} {{$t('dashboard.card-plan.tiempo')}} 
                            </p>
                            </div>
                        <a href="#" class="link" @click="getGroupPlanFreeze" v-if="!flagPlanPrueba && ((groupsPlan.flagGroup && this.$store.state.is_representative) || !groupsPlan.flagGroup)" ><span>{{$t('dashboard.card-plan.question')}}</span></a>
                    </div>
                    <template v-else>
                        <div class="card card-availability">
                            <h6 class="sub-title text-left mb-4"><span>{{$t('dashboard.card-proof.titulo')}} </span></h6>
                            <div class="d-flex">
                                <img src="@/assets/img/girdRequest-2.png">
                                <div class="pl-5" v-if="nextClass">
                                    <h6 class="d-flex align-items-center"><icon name="calendar" /><span class="spanSubTitle">{{nextClass.strStartDate}}</span></h6>
                                    <h6 class="d-flex align-items-center"><icon name="time" /><span class="spanSubTitle">{{nextClass.strStartEndDate}}</span></h6>
                                    <button v-show="!nextClassUrlDisabled" type="button" class="btn btn-primary mt-3"  :class="nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClassLocal(nextClass.linkClass,$moment,nextClass.startDate,nextClass.endDate)" >
                                        <b-icon icon="camera-video" aria-hidden="true"></b-icon> {{$t('dashboard.card-proof.button-1')}}
                                    </button>
                                </div>
                                <div class="pl-5" v-else>
                                    <h6 class="d-flex align-items-center"><span class="spanSubTitle"> {{$t('dashboard.card-proof.text')}}</span></h6>
                                    <b-button variant="primary" class="mt-3" @click="$router.push({name:'horario'})">
                                        <icon name="calendar" class="mr-2" /> {{$t('dashboard.card-proof.button-2')}}
                                    </b-button>
                                </div>
                            </div>    
                        </div>
                        <div class="card card-availability mt-4 min-card-3" v-if="teacher">
                            <h6 class="sub-title text-left mb-4"><span> {{$t('dashboard.card-cancelaciones.titulo')}}</span></h6>
                            <div v-if="classesCancelled && classesCancelled.length != 0">
                                <div class="content-scroll cancellations pl-0">
                                    <div v-for="item in classesCancelled" :key="item.id" :id="'class_cancelled_'+item.id" class="card-title mb-3">
                                        <span class="material-icons-outlined">warning</span>
                                        <span class="w-100 ml-3">
                                            <p>{{$t('dashboard.card-cancelaciones.text', {Day: item.strStartDate, S: item.strStartEndDate.split("-")[0].split(":")[0] == 1 ? 'la' : 'las', Hour: item.strStartTime })}} </p>
                                            <a href="#" class="link" @click="getWeekSchedule(item.id, item.startDate)"><span>{{$t('dashboard.card-cancelaciones.question')}}</span></a>
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div v-else class="h-100 d-flex align-items-center justify-content-center"> 
                                {{$t('dashboard.card-cancelaciones.else.text')}}
                            </div>
                        </div>
                    </template>
                </b-col>
            </b-row>
            <b-row  v-if="groupsPlan != null && teacher != null && !flagPlanPrueba " class="mt-4"> 
                <!-- <b-row  v-if="true"> -->
                <b-col>
                    <div class="card card-body card-availability min-card">
                        <h6 class="sub-title text-left mb-4"><span>{{$t('dashboard.card-next-class.titulo')}}</span></h6>
                        <div class="d-flex align-items-center">
                            <img src="@/assets/img/girdRequest-2.png">
                            <div class="pl-4" v-if="nextClass">
                                <!-- <span class="d-flex mb-1 ml-2"><span class="material-icons-outlined">date_range</span><span class="sub-title text-left title-sub"><span>{{nextClass.strStartDate}}</span></span></span> -->
                                <h6 class="d-flex align-items-center pl-2"><icon name="calendar" /><span class="spanSubTitle">{{nextClass.strStartDate}}</span></h6>
                                <!-- <span class="d-flex mb-1 ml-2"><span class="material-icons-outlined">schedule</span><h6 class="sub-title text-left title-sub"><span>{{nextClass.strStartEndDate}}</span></h6></span> -->
                                <h6 class="d-flex align-items-center pl-2"><icon name="time" /><span class="spanSubTitle">{{nextClass.strStartEndDate}}</span></h6>
                                <button v-show="!nextClassUrlDisabled"  type="button" class="btn btn-primary mt-3"  :class="nextClass.linkClass != null? '': 'disabled'"  @click="openLinkClassLocal(nextClass.linkClass,$moment,nextClass.startDate,nextClass.endDate)">
                                    <icon name="video" /> {{$t('dashboard.card-next-class.button')}}
                                </button>
                            </div>
                            <div class="pl-4 d-flex align-items-center mb-4" v-else >
                                {{$t('reusables.no-class-schedule')}}
                            </div>
                        </div>
                    </div>
                </b-col>
                <b-col>
                    <div class="card card-body card-availability min-card">
                        <h6 class="sub-title text-left mb-4"><span>{{$t('dashboard.card-cancelaciones.titulo')}}</span></h6>
                        <div v-if="classesCancelled && classesCancelled.length != 0">
                            <div class="content-scroll cancellations pl-0">
                                <div v-for="item in classesCancelled" :key="item.id" :id="'class_cancelled_'+item.id" class="card-title mb-3">
                                    <span class="material-icons-outlined">warning</span>
                                    <span class="w-100 ml-3">
                                        <p>{{$t('dashboard.card-cancelaciones.text', {Day: item.strStartDate, S: item.strStartEndDate.split("-")[0].split(":")[0] == 1 ? 'la' : 'las', Hour: item.strStartTime })}} </p>
                                        <a href="#" class="link" @click="getWeekSchedule(item.id, item.startDate)"><span>{{$t('dashboard.card-cancelaciones.question')}}</span></a>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div v-else class="h-100 d-flex align-items-center justify-content-center"> 
                            {{$t('dashboard.card-cancelaciones.else.text')}}
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div  v-if="!(groupsPlan != null && !flag_subject)">
            <div class="card card-body card-availability update mt-4 px-5"   v-if="listComments.length != 0" >
                <div class="w-100">
                    <h6 class="sub-title text-left mb-4"><span v-if="listComments[0].teacher">{{$t('dashboard.card-commentary.titulo')}} {{listComments[0].teacher.strFullName}}</span></h6>
                    <div class="content-scroll pl-0">
                        <div v-for="item in listComments" :key="item.id" :id="'comment_'+item.id">
                            <p class="title-gris" style="margin-bottom: 5px;">{{$t('dashboard.card-commentary.sub-titulo')}} {{item.dateClass}} - {{item.subjectsName}}</p>
                            <p style="margin-bottom: 20px;">
                                {{item.comment}}
                            </p>
                        </div>
                        
                    </div>
                </div>
            </div>
            </div>
            <div class="card card-body card-availability update mt-4" :class="{'justify-content-center':!changueTeacher}" v-if="groupsPlan && !teacher  && flag_subject" >
                <div>
                    <img src="@/assets/img/young-test.png"  class="left" alt="">
                    <img src="@/assets/img/activities-proof.png" class="right" alt="">
                    <section class="text-center">
                        <img class="mb-2" src="@/assets/img/circle-like.png" alt="">
                    </section>
                    <div class="text-center w-100" v-if="!flagPlanPrueba">
                        <h6 class="sub-title mb-0"><span>{{$t('dashboard.card-footer-plan.titulo')}}</span></h6>
                        <p class="mb-3 justify-content-center">{{$t('dashboard.card-footer-plan.text.1')}}</p>
                        <p class="mb-3 justify-content-center"> {{$t('dashboard.card-footer-plan.text.2')}}<br> {{$t('dashboard.card-footer-plan.text.3')}}</p>
                        <b-button variant="primary" @click="$router.push({name:'horario'})">
                            <icon name="calendar" class="mr-2 "/> {{$t('dashboard.card-footer-plan.buttons')}}
                        </b-button>
                    </div>
                    <div class="text-center w-100" v-else>
                        <h6 class="sub-title mb-2"><span>{{$t('dashboard.card-footer-proof.titulo')}} <br>{{$t('dashboard.card-footer-proof.titulo2')}}</span></h6>
                        <p class="justify-content-center mb-3">{{$t('dashboard.card-footer-proof.text')}}<br> {{$t('dashboard.card-footer-proof.text2')}}</p>
                        <b-button variant="primary" @click="$router.push({name:'horario'})">
                            <icon name="calendar" class="mr-2 "/> {{$t('dashboard.card-footer-proof.button')}}
                        </b-button>
                    </div>
                </div>
            </div>

            
            <div id="divAlumnoSinPlanVigente"  class="card card-body card-availability update mt-4" :class="{'justify-content-center':!changueTeacher}"  v-if="groupsPlan == null">
                <div >
                    <img src="@/assets/img/young-test.png"  class="left" alt="">
                    <img src="@/assets/img/activities-proof.png" class="right" alt="">
                    <div class="text-center">
                        <img class="mb-4" src="@/assets/img/circle-calendar.png" alt="">
                    </div>
                
                    <div class="text-center w-50 m-auto">
                        <h6 class="sub-title mb-4"><span>{{$t('dashboard.card-SinPlanVigente.text')}} </span></h6>
                        <p class="mb-4 justify-content-center">{{$t('dashboard.card-SinPlanVigente.text2')}}</p>
                        <b-button variant="primary" @click="$router.push({name:'compra',params: { step: 0 }})">
                            {{$t('dashboard.card-SinPlanVigente.button')}}
                        </b-button>
                    </div>
                </div>
            </div>

            <!-- Past teachers still eligible for review (>=3 completed classes, package ended
                 within the review window) that aren't the student's current teacher. Shown
                 regardless of whether the student has an active plan, since a student whose
                 package already ended (no current teacher) would otherwise have no way at all
                 to reach this. -->
            <div id="divPendingTeacherReviews" class="card card-body card-availability mt-4" v-if="pendingTeacherReviews.length > 0">
                <h6 class="sub-title text-left mb-4"><span>{{$t('dashboard.card-pending-teacher-reviews.titulo')}}</span></h6>
                <div v-for="item in pendingTeacherReviews" :key="item.personTeacherId" class="d-flex align-items-center justify-content-between mb-3">
                    <div class="d-flex align-items-center">
                        <b-avatar size="48px" class="flex-shrink-0" variant="light" :src="item.personsTeachers.person.photo ? item.personsTeachers.person.photo : urlPhoto.PHOTO_TEACHER_DEFAULT"></b-avatar>
                        <h6 class="sub-title text-left ml-3 mb-0"><span>{{item.personsTeachers.person.firstName}} {{item.personsTeachers.person.lastName}}</span></h6>
                    </div>
                    <b-button variant="primary" size="sm" @click="rateTeacher(item)">{{$t('dashboard.card-pending-teacher-reviews.button')}}</b-button>
                </div>
            </div>

            <div id="divAlumnoSinCurso" class="card card-body card-availability mt-4 min-card"  v-if="(groupsPlan != null && !flag_subject)" >
                <h6 style="margin-bottom:0px !important;" class="sub-title text-center "><span>{{$t('dashboard.card-without-courses.titulo-1')}}</span></h6>
                <h6 style="margin-bottom:0px !important;" class="sub-title text-center "><span>{{$t('dashboard.card-without-courses.titulo-2')}}</span></h6>
                    <p  style="justify-content: center; margin:20px 0px;">{{$t('dashboard.card-without-courses.text')}}</p>
                <div style="display: flex; justify-content: center;">
                            <b-button variant="primary" @click="$router.push({ name:'cursos', params:{index:1} })">
                        {{$t('dashboard.card-without-courses.button')}}
                    </b-button>
                </div>       
            </div>

            <b-modal id="modalTeacher" ref="modalTeacher"
            :hide-footer="true" 
            :hide-header="true" 
            :centered="true">
            <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modalTeacher')">
                <h6 class="sub-title"><span>{{$t('dashboard.modal-changue-teacher.titulo')}}</span></h6>
                <p class="text-center" v-if="groupsPlan" >
                    {{$t('dashboard.modal-changue-teacher.text', {NRO: groupsPlan.limitTeacherChanges})}}  
                </p>
	                    <ul class="mt-4 list-ul pl-3 pr-3" v-if="teacherChangesInfo"> 
	                        <li>{{$t('dashboard.modal-changue-teacher.options.1', {NRO:teacherChangesInfo.quantityTeacherChanges, VEZ: teacherChangesInfo.quantityTeacherChanges == 1 ? $t('reusables.time') : $t('reusables.times') , QUEDA:teacherChangesInfo.quantityTeacherChanges == 1 ? $t('reusables.queda')  : $t('reusables.quedan') , NRO2: groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges, S: groupsPlan.limitTeacherChanges - teacherChangesInfo.quantityTeacherChanges == 1 ? '': 's'})}} 
	                        </li>
	                    </ul>
                    <div class="change-teacher-rating mb-4" v-if="teacher && teacher.person">
                        <label class="font-weight-bold mb-2 change-teacher-rating-label">
                            {{ lang == 'es' ? 'Califica a tu profesor(a) antes de continuar.' : 'Rate your teacher before continuing.' }}
                        </label>
                        <div class="d-flex justify-content-center">
                            <b-form-rating v-model="changeTeacherRating" stars="5" no-border size="sm" class="rating-gold" :disabled="ratingPosted"></b-form-rating>
                        </div>
                        <b-form-textarea v-model="changeTeacherRatingComment" :placeholder="lang == 'es' ? 'Comentario (opcional)' : 'Comment (optional)'" rows="2" no-resize class="mt-2" :disabled="ratingPosted"></b-form-textarea>
                        <small v-if="changeRatingError" class="text-danger d-block mt-1">{{ changeRatingError }}</small>
                        <button v-if="!ratingPosted" type="button" class="btn btn-primary d-block mx-auto mt-4" :disabled="!changeTeacherRating || showSpinnerRating" @click="postChangeTeacherRating">
                            <template v-if="!showSpinnerRating">{{ lang == 'es' ? 'Publicar calificación' : 'Post rating' }}</template>
                            <b-spinner v-else style="width: 1rem !important; height: 1rem !important ;" variant="light" label="Spinning"></b-spinner>
                        </button>
                        <p v-else class="text-success text-center mb-0 mt-2 font-weight-bold">{{ lang == 'es' ? '✓ Calificación guardada' : '✓ Rating saved' }}</p>
                    </div>
	                <div class="card card-body  mb-4 mt-4" v-if="teacher && teacher.person">
	                    <!-- <b-avatar variant="info" :src="teacher.person.photo"></b-avatar> -->
	                    <b-avatar size="7rem" v-if="teacher && teacher.person" variant="light" :src="teacher.person.photo ? teacher.person.photo : urlPhoto.PHOTO_TEACHER_DEFAULT"></b-avatar>
                    <div class="ml-4">
                        <p class="mb-0">{{$t('dashboard.modal-changue-teacher.card.text')}}</p>
	                        <h6><span class="spanSubTitle">{{teacher.person.strFullName}}</span></h6>
	                    </div>
	                </div>
	                <button type="button" class="btn btn-primary   d-block m-auto" 
	                    :disabled="limitChange-quantityChange == 0 || !ratingPosted || showSpinnerChange" @click="submitTeacherChange">
	                    <template v-if="!showSpinnerChange">{{$t('dashboard.modal-changue-teacher.card.button')}}</template>
                        <b-spinner
                            v-else
                            style="width: 1rem !important; height: 1rem !important ;"
                            variant="light"
                            label="Spinning"
                        ></b-spinner>
	                </button>
	                
	            </b-modal>

	            <b-modal id="freezePlan" ref="freezePlan"  :hide-footer="true"  :hide-header="true"  :centered="true">
                <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('freezePlan')">
                <h6 class="sub-title mb-4"><span>{{$t('dashboard.modal-freeze-plan.titulo')}}</span></h6>
                <p class="text-center" v-if="groupsPlan">
                    {{$t('dashboard.modal-freeze-plan.text.1', {NRO: groupsPlan.limitFrozenDays,  DAY:groupsPlan.limitFrozenDays == 1 ?  $t('reusables.day'): $t('reusables.days')})}}   
                </p>
                <ul class="mt-4 list-ul pl-2 pr-2" v-if="freezeInfo" > 
                    <li v-for="(item,i) in freezeInfo.groupsPlanFreeze" :key="i" :id="'freezeDate_'+i">
                        {{$t('dashboard.modal-freeze-plan.options.1', {DATE: item.startDateStr, NRO: item.days, DAY:item.days == 1 ?  $t('reusables.day'): $t('reusables.days') } )}}
                    </li>

                    <li>{{$t('dashboard.modal-freeze-plan.options.2', {NRO:freezeInfo.daysToFreeze, DAY:freezeInfo.daysToFreeze == 1 ? $t('reusables.day'): $t('reusables.days')} )}}</li>
                </ul>
                <div class="card card-body mb-4 mt-4">
                    <!-- <b-avatar variant="info" :src="teacher.person.photo"></b-avatar> -->
                    <img src="@/assets/img/icon-calendar.png" alt="">
                    <section>
                        <p>{{$t('dashboard.modal-freeze-plan.card.text.1')}} 
                            <b-form-input id="range-days" v-model="formFreeze.days" type="number" min="1" 
                                required v-bind:class="{ error: $v.formFreeze.days.$error}" @blur="$v.formFreeze.days.$touch()" >
                            </b-form-input>
                            {{$t('dashboard.modal-freeze-plan.card.text.2')}}
                        </p>
                        <div class="error-input">{{ validationFormFreeze($v.formFreeze.days)}}</div>
                        <p>{{$t('dashboard.modal-freeze-plan.card.text.3')}}
                            <b-form-datepicker v-model="formFreeze.date" 
                                :locale="lang"
                                :hide-header="true" 
                                :value-as-date="false"
                                :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                                required v-bind:class="{ error: $v.formFreeze.date.$error}" @blur="$v.formFreeze.date.$touch()"
                            ></b-form-datepicker>
                        </p>
                        <div class="error-input">{{ validationFormFreeze($v.formFreeze.date)}}</div>
                    </section>
                </div>
                <div class="error-input text-center mb-3" v-show="messageFreeze.length > 0">{{messageFreeze}}</div>
                <div class="text-center">
                    <b-button v-if="freezeInfo" variant="primary" @click="validatePlanFreeze" 
                        :class="{ loading: isLoading }" :disabled="freezeInfo.daysToFreeze == 0" >{{$t('dashboard.modal-freeze-plan.button')}}
                    </b-button>
                </div>
                
            </b-modal>
 
            <b-modal id="modalGroupData" ref="modalGroupData" :hide-footer="true" :hide-header="true" :centered="true">
                <img class="close" src="@/assets/img/close_red.png" @click="$bvModal.hide('modalGroupData')">
                <h5 class="sub-title"><span>{{$t('dashboard.modal-group-data.titulo', {Code: groupData.code})}}</span></h5>
                <b-row>
                    <b-col class="pr-5">
                        <div class="mb-4" v-if="groupData.company">
                            <h6 class="blue">{{$t('dashboard.modal-group-data.text.1')}}</h6>
                            <p>{{groupData.company}}</p>
                            <!-- <p>Servicios de Publicidad y Marketing Omelet EIRL</p> -->
                        </div>
                        <div>
                            <h6 class="blue">{{$t('dashboard.modal-group-data.text.2')}}</h6>
                            <p>{{groupData.levels ? groupData.levels.abbreviation : ""}}</p>
                        </div>
                    </b-col>
                    <b-col class="pl-5">
                        <h6 class="blue">{{$t('dashboard.modal-group-data.text.3')}}</h6>
                        <ul>
                            <li v-for="(student, index) in groupData.listPersonsStudents" :key="index">
                                <span>{{student.person.strFullName}}</span><icon v-if="student.flagRepresentative" name="star-2" class="ml-2 leader-star"/>
                            </li>
                        </ul>
                    </b-col>
                </b-row>
                <div class="text-center mt-4">
                    <img src="@/assets/img/group.png"  />
                </div>
            </b-modal>

            <b-toast id="toast-check-modal-confirm" variant="none" no-close-button toaster="b-toaster-top-center">
                <img src="@/assets/img/ico-check.png" style="margin-right: 10px; margin-top: -2px" />
                {{ message }}
            </b-toast>
            <b-toast id="toast-check-modal-error" variant="none" no-close-button toaster="b-toaster-top-center">
                <img src="@/assets/img/ico-equis.png" style="margin-right: 10px; margin-top: -2px" />
                {{ message }}
            </b-toast>
            <ModalCalendarWeekStudent :calendarEvents="calendarEvents"/>
            <ModalRecommend ref="modalScorePlataform" @close-window-recommend='onCompanyReviewClosed()'/>
         
            <modalScoreTeacher ref="modalScore" @close-window-recommend='onTeacherReviewClosed()'/>

            <!-- Confirmation before publishing the inline rating (client: confirm they want to leave the rating) -->
            <b-modal v-model="showRatingConfirm" centered :hide-footer="true" :hide-header="true">
                <h6 class="sub-title mb-2"><span>{{ lang == 'es' ? '¿Deseas publicar esta calificación?' : 'Do you want to publish this rating?' }}</span></h6>
                <div class="d-flex justify-content-center mt-4">
                    <button class="btn btn-danger mr-3" style="display:initial" @click="showRatingConfirm = false">{{ lang == 'es' ? 'Cancelar' : 'Cancel' }}</button>
                    <b-button variant="primary" :disabled="ratingLoading" @click="submitTeacherRating(false)">{{$t('modals.score-teacher.btn-1')}}</b-button>
                </div>
            </b-modal>
            <b-modal id="modal-next-linkClass" :centered="true">
                <template #modal-header="{ close }">
                    <img class="close" src="@/assets/img/close_red.png" @click="close()">
                </template>
                <p class="text-center mb-0" >{{ messageLinkClassResult }}</p>
                <template #modal-footer>
                    <b-button @click="$bvModal.hide('modal-next-linkClass')" variant="primary">Aceptar</b-button>
            </template>
            </b-modal>
        </div>
        
</template>
<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import Progress from "easy-circular-progress";
import { required, numeric, maxValue, minValue} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';
import ModalCalendarWeekStudent from '@/components/modals/modalCalendarDemo'
import ModalRecommend from '@/components/modals/modal-recommend'
import modalScoreTeacher from '@/components/modals/modal-score-teacher'
import * as Constants from "@/assets/js/appConstants";
import { hideSidebarNav } from '@/assets/js/util.js';
import { horarioObtenerNameClaseEnEs, horarioObtenerColorClase , openLinkClass, convertTimeToUserTimeFormat, getNextClassDate, getNextClassTime} from '@/assets/js/util.js';
import { DEVICE } from '@/assets/js/appConstants';
import {mapState} from "vuex";



const lang = localStorage.getItem('lang') || 'es';
const formFreezeMessages= {
    required: function (){
        return this.$t('validations.formFreezeMessages.required')
    },
    requiredFecha: function (){
        return this.$t('validations.formFreezeMessages.requiredDate')
    },
    numeric: function(){
        return this.$t('validations.formFreezeMessages.numeric')
    },
    minValueDias: function(){
        return this.$t('validations.formFreezeMessages.minValueDias')
    },
    minValue: function(){
        return this.$t('validations.formFreezeMessages.minValue')
    },
    flagValidateDays: function(){
        return this.$t('validations.formFreezeMessages.flagValidateDays')
    },
};
 
export default {
    data(){
        return{
            showSpinnerChange:false,
            messageLinkClassResult:null,
            pendingTeacherReviews: [],
            ratingContextTeacherId: null,
            currentTeacherRatable: false,
            teacherRatingValue: null,           
            teacherRatingComment: '',          
            showInlineRating: false,           
            ratingLoading: false,              
            showRatingConfirm: false,          
            ratingError: '',                    
            API_URL: process.env.VUE_APP_API_URL,
            urlPhoto: Constants.IMAGENES,
            teacherAvailability:false, 
            availabilityClass:false ,
            levels: [],
            subjects:[],
            groupsPlan:null,//nul
            flagMostrarDashboard:false, //false
            teacher:null, //null
            nextClass:null,
            nextClassUrlDisabled:false,
            classesCancelled:null, 
            listComments:[],
            flagPlanPrueba:false,
            freezeInfo: null,
            teacherChangesInfo: null,
            calendarEvents:null,
            limitChange :0,
            quantityChange : 0,
            groupsPlanFreeze: null,
            changueTeacher:false,
            changeTeacherRating: null,
            ratingPosted: false,
            showSpinnerRating: false,
            changeTeacherRatingComment: '',     
            changeRatingError: '',        
            startDate: new Date(),
            formFreeze:{
                days:null,
                date:null
            },
            message:"",
            messageFreeze: "",
            isLoading:false,
            openLinkClass:openLinkClass,
            lang:lang,
            groupData: {},
            modalConfirmTeacher: false,
            horarioObtenerNameClaseEnEs : horarioObtenerNameClaseEnEs,
            isDesktop: window.innerWidth > DEVICE.DESKTOP,
        }
    },
    components: {
        Progress,
        ModalCalendarWeekStudent,
        ModalRecommend,
        modalScoreTeacher
    },
    validations: {
        formFreeze:{
            days: {
                required,
                numeric,
                minValueDias: minValue(1),
                flagValidateDays(value) {
                    if (this.groupsPlan == null) return true;

                    return new Promise((resolve, reject) => {
                        return baseInstanceAxios.get(this.API_URL + `/resources/dashboard/ValidateSaveFreeze?id=${this.groupsPlan.id}&day=${value}` )
                            .then(response => {
                                resolve(response.data.return);
                            })
                            .catch(error => {
                                reject(error);
                            })

                    })
                        
                },
            },
            date:{
                requiredFecha(value) {
                    return (required(value))                  
                        
                },
                minValue: value => value > (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().slice(0, -1)
            }
        }    
    },
    computed: {
        ...mapState(['flag_subject','flagValidateCalifications']),

    
        remainingUnscheduledHours() {
            if (!this.groupsPlan) return 0;
            let total = this.groupsPlan.duration || 0;
            let scheduled = this.groupsPlan.totalHoursSchedule || 0;
            let rem = total - scheduled;
            return rem > 0 ? Math.round(rem * 100) / 100 : 0;
        },
        showExpiryReminder() {
            if (!this.groupsPlan || this.flagPlanPrueba) return false;
            let days = this.groupsPlan.strDaysNumber;
            return days != null && days >= 0 && days <= 30 && this.remainingUnscheduledHours > 0;
        },
        // Teacher's public rating badge (backend now sends totalQualification as a decimal average + totalCommentary count)
        teacherRatingCount() {
            return (this.teacher && this.teacher.totalCommentary) ? this.teacher.totalCommentary : 0;
        },
        teacherRatingAvg() {
            if (!this.teacher || !this.teacher.totalQualification) return null;
            return Number(this.teacher.totalQualification).toFixed(1);
        },

        User: {
            get() {
                return this.$store.state.user;
            },
        }
    },
    created(){
		if(!this.$store.state.is_teacher  ){
			hideSidebarNav(this.User, this.$store.state.datosSidebar);
		}
	},
	mounted: function () {
        if(this.flagValidateCalifications){
            let data = {
                typeScore : 1
            }
        
            this.$refs.modalScorePlataform.getShowModalScoreIA(data)
        }
     
		this.getDashboardData();
	},
    methods: {
        handleEvent(){
            this.message = this.$t('mjesRegistro.rating-recorded-correctly')
            this.$bvToast.show("toast-check-modal-confirm");
        },
        validationFormFreeze: validationMessage(formFreezeMessages),
        
		getDashboardData: function() {
            
            baseInstanceAxios
                .get(this.API_URL + `/resources/dashboard/GetStudentConsolidatedById?personStudentId=${this.User.personStudentId}` )
                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        this.levels = response.data.entity.listLevels;
                        this.groupsPlan = response.data.entity.groupsPlan;
                        this.limitChange  = response.data.entity.groupsPlan ? response.data.entity.groupsPlan.limitTeacherChanges : 0
                        this.groupsPlanFreeze = response.data.entity.groupsPlanFreeze;
                         
                        if(this.groupsPlan != null){
                            this.subjects = response.data.entity.listSubjects;

                            if(!response.data.entity.flagChangeTeacher){
                                this.teacher = response.data.entity.personsTeachers;
                            }
                            if(response.data.entity.flagTeacher){
                                //console.log("response.data.entity.groupScheduleStudentsDetails: ",response.data.entity.groupScheduleStudentsDetails.strStartEndDate)
                                this.nextClass = response.data.entity.groupScheduleStudentsDetails;

                                //
                                let format_day = "DD/MM/YYYY";
                                let format_time = "h:mm a";
                                if (this.nextClass) {
                                 this.nextClass.strStartDate = getNextClassDate(this.nextClass.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                                 this.nextClass.strStartEndDate = getNextClassTime(this.nextClass.startDate, this.nextClass.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time);
                                }    
                                                               
                                this.nextClassUrlDisabled = this.nextClass ? (this.$moment(this.nextClass.startDate) < new Date() && this.$moment(this.nextClass.endDate) <= new Date() ) : false;
                                this.classesCancelled =  response.data.entity.listGroupScheduleStudentsDetailsCancel 
                                if(this.classesCancelled .length != 0){

                                    this.classesCancelled.forEach(element => {
                                        element.strStartDate = getNextClassDate(element.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                                        element.strStartEndDate = getNextClassTime(element.startDate, element.endDate, this.$store.state.user.timeZoneName, this.$moment, format_time);
                                        element.strStartTime = element.strStartEndDate.split("-")[0].trim();
                                    });
                                }

                                if(response.data.entity.listComments.length != 0){

                                    response.data.entity.listComments.forEach(element => {
                                        let json = {
                                            dateClass : element.schedule.strStartDate,
                                            subjectsName: element.subjectsName,
                                            comment : element.comment,
                                            teacher: element.schedule.personTeacher != null ? element.schedule.personTeacher.person : null
                                        };  
                                        this.listComments.push(json)
                                    });
                                }
                                
                            }

                            //SI ES PLAN DE PRUEBA O NO
                            this.flagPlanPrueba = this.groupsPlan.flagPlanTest; //TODO
                            //this.nextClass = null;
                            //this.lastClassComment = null;
                            //this.teacher = null;
                        }
                        if(this.isDesktop){
							this.flagMostrarDashboard = true;
						}
                        this.loadTeacherReviewEligibility();
                    }
                });
        },
        loadTeacherReviewEligibility: function() {
            let self = this;
            baseInstanceAxios
                .get(`${this.API_URL}/Resources/PersonsTeachers/GetPendingTeacherReviewsByStudent?PersonStudentId=${this.User.personStudentId}`)
                .then(resp => {
                    let list = (resp && resp.data && resp.data.list) ? resp.data.list : [];
                    self.currentTeacherRatable = !!(self.teacher && self.teacher.id && list.some(function (x) { return x.personTeacherId === self.teacher.id; }));
                    // Everything else in the list is a past teacher still eligible for review --
                    // the current teacher (if any) already has their own rating UI above.
                    self.pendingTeacherReviews = list.filter(function (x) {
                        return !(self.teacher && self.teacher.id && x.personTeacherId === self.teacher.id);
                    });
                })
                .catch(function () { /* never block the dashboard */ });
        },
        rateTeacher: function(item) {
            this.ratingError = '';
            this.ratingContextTeacherId = item.personTeacherId;
            this.$refs.modalScore.getShowModalScoreTeacher({
                personTeacherId: item.personTeacherId,
                nameTeacher: item.personsTeachers && item.personsTeachers.person ? (item.personsTeachers.person.firstName + ' ' + item.personsTeachers.person.lastName) : '',
                photoTeacher: item.personsTeachers && item.personsTeachers.person ? item.personsTeachers.person.photo : '',
                typeScore: 2,
                qualification: 0,
                commentary: '',
                id: 0,
                flagPublished: null
            });
        },
        // Inline rating (no pop-up): open/close the panel that lives inside the "Mi profesor(a)" card.
        toggleInlineRating: function() {
            if (!this.currentTeacherRatable) return;
            if (this.showInlineRating) { this.closeInlineRating(); return; }
            this.ratingError = '';
            this.showInlineRating = true;
        },
        closeInlineRating: function() {
            this.showInlineRating = false;
            this.ratingError = '';
            this.teacherRatingValue = null;
            this.teacherRatingComment = '';
        },
        // Publish -> validate a star is chosen, then ask for confirmation before actually saving.
        confirmPublishRating: function() {
            if (!this.teacherRatingValue) {
                this.ratingError = (lang === 'es') ? 'Selecciona una calificación (estrellas).' : 'Please select a star rating.';
                return;
            }
            this.ratingError = '';
            this.showRatingConfirm = true;
        },
        rateCurrentTeacher: function(mandatoryForChange) {
            if (!this.teacher || !this.teacher.id) return;
            this.ratingError = '';
            this.mandatoryChangePending = (mandatoryForChange === true);
            this.$refs.modalScore.getShowModalScoreTeacher({
                personTeacherId: this.teacher.id,
                nameTeacher: this.teacher.person ? this.teacher.person.strFullName : '',
                photoTeacher: this.teacher.person ? this.teacher.person.photo : '',
                typeScore: 2,
                qualification: 0,
                commentary: '',
                id: 0,
                flagPublished: null
            });
        },
        submitTeacherRating: function(fromChange) {
            if (!this.teacher || !this.teacher.id) return;
            if (!this.teacherRatingValue) {
                this.ratingError = (lang === 'es') ? 'Selecciona una calificación (estrellas).' : 'Please select a star rating.';
                return;
            }
            this.ratingError = '';
            this.ratingLoading = true;
            let self = this;
            let json = {
                Id: 0,
                PersonTeacherId: this.teacher.id,
                Qualification: this.teacherRatingValue,
                Commentary: this.teacherRatingComment || '',
                PersonStudentId: this.User.personStudentId,
                UserCreated: this.$store.state.user.email
            };
            baseInstanceAxios
                .post(`${this.API_URL}/resources/PersonsTeachers/SaveCalification`, json)
                .then(function (resp) {
                    self.ratingLoading = false;
                    self.showRatingConfirm = false;
                    if (resp && resp.data && resp.data.value > 0) {
                        self.currentTeacherRatable = false;
                        self.teacherRatingValue = null;
                        self.teacherRatingComment = '';
                        self.showInlineRating = false;
                        self.handleEvent();
                        if (fromChange) { self.openTeacherChangeModal(); }
                    }
                })
                .catch(function () { self.ratingLoading = false; self.showRatingConfirm = false; });
        },
        openTeacherChangeModal: function() {
            this.changeTeacherRating = null;
            this.changeTeacherRatingComment = '';
            this.changeRatingError = '';
            this.ratingPosted = false;
            this.showSpinnerRating = false;
            var datos = { id: this.groupsPlan.id };
            baseInstanceAxios
                .post(this.API_URL + `/resources/Dashboard/GetQuantityGroupsPlanTeacherChanges`, datos)
                .then(response => {
                    if (response.data != null && response.data.entity != null) {
                        this.teacherChangesInfo = response.data.entity;
                        this.quantityChange = response.data.entity.quantityTeacherChanges;
                        this.$bvModal.show('modalTeacher');
                    }
                });
        },
        onCompanyReviewClosed: function() {
            // Company/NPS review only. The teacher rating now lives in the Mi profesor(a) card.
            this.handleEvent();
        },
        onTeacherReviewClosed: function() {
            // Fires only after a rating is submitted (stars are required; comment optional).
            this.handleEvent();
            this.currentTeacherRatable = false;
            if (this.ratingContextTeacherId) {
                this.pendingTeacherReviews = this.pendingTeacherReviews.filter(function (x) {
                    return x.personTeacherId !== this.ratingContextTeacherId;
                }, this);
                this.ratingContextTeacherId = null;
            }
            if (this.mandatoryChangePending) {
                this.mandatoryChangePending = false;
                this.openTeacherChangeModal();
            }
        },
        getGroupPlanFreeze:function(){
            this.formFreeze = {
                days:null,
                date:null
            };
            this.messageFreeze = "";
            this.$v.$reset();


            var datos = {
                id: this.groupsPlan.id
            };
            baseInstanceAxios
                .post(this.API_URL + `/resources/Dashboard/GetGroupsPlanfreeze`, datos)
                .then(response => {
                    if(response.data != null && response.data.entity != null){
                        this.freezeInfo = response.data.entity;
                        this.$bvModal.show('freezePlan')

                    }
                });
        }, 
        validatePlanFreeze:function(){
            if (!this.isLoading) {
                this.messageFreeze = "";
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }
                var dateMomentObject = this.$moment(this.formFreeze.date ,"YYYY/MM/DD"); 
                var datos = {
                    groupPlanId: this.groupsPlan.id,
                    startDate: dateMomentObject.toDate(),
                    days: parseInt(this.formFreeze.days),
                    userCreated: this.User.email
    
                };
                this.isLoading = true;
                baseInstanceAxios
                    .post(this.API_URL + `/resources/Dashboard/SaveGroupsPlanfreeze`, datos)
                    .then(response => {
                        if(response.data != null ){

                            if(response.data.return){
                                if(response.data.value != -1){
                                    this.message = this.$t('dashboard.modal-group-data.messages.1');
                                    this.$bvToast.show("toast-check-modal-confirm");
                                    this.formFreeze = {
                                        days:null,
                                        date:null
                                    };
                                    this.groupsPlan.strPurchaseExpirationDate = response.data.message;
                                    this.$bvModal.hide('freezePlan');
                                }else if (response.data.value == -1){
                                    this.messageFreeze = this.$t('dashboard.modal-group-data.messages.2');;

                                }
                                
                            }else{
                                this.message = this.$t('dashboard.modal-group-data.messages.3');;
                                this.$bvToast.show("toast-check-modal-error");
                            }
                        }
                        this.isLoading = false;
                    })
                    .catch(function (error) {
                      
                        this.message = this.$t('dashboard.modal-group-data.messages.3');;
                        this.$bvToast.show("toast-check-modal-error");
                        this.isLoading = false;
                    });
            }
            
        }, 
        // "Do you want to change your teacher?" opens ONLY the teacher-change pop-up.
        getTeacherChanges: function() {
            this.openTeacherChangeModal();
        },
        getWeekSchedule: function(id, date) {
            this.$bvModal.show('modalCalendarWeek');
            this.calendarEvents = [];

            var datos = {
                id: id,
                //startDateTz: date
            };
            baseInstanceAxios
                .post(this.API_URL + `/resources/Dashboard/GetWeekSchedule`, datos)
                .then(response => {
                    if(response.data != null && response.data.list != null){
                        let titleCourse = this.subjects.map(x => x.name);
                        let format_time = "YYYY-MM-DDTHH:mm:ss";
                        let self = this;
                        
                        this.calendarEvents = response.data.list.map(item => (
                            {   id: item.id, 
                                start: convertTimeToUserTimeFormat(item.startDate, self.$store.state.user.timeZoneName, self.$moment, format_time)  ,
                                end: convertTimeToUserTimeFormat(item.endDate, self.$store.state.user.timeZoneName, this.$moment, format_time)   ,
                                editable:false,
                                color: horarioObtenerColorClase(item.stateClass.value),
                                title: this.$t('horario.calendario.label-calendar-teacher', {TeacherName: item.personTeacher.person.strFullName}),
                                //flagGroup: item.flagGroup,
                                flagPlanTest: item.flagPlanTest,
                                personName: item.personTeacher.person.strFullName,
                                //code: item.code,
                                stateClass: item.stateClass.value,
                                titleCourse: titleCourse.join(", "),
                                typeOfSchedule: item.typeOfSchedule
                            })
                        );
               

                    }
                }); 
        }, 
        // Step 1: post the rating on its own (client wants the review saved before any teacher change).
        postChangeTeacherRating(){
            if (!this.changeTeacherRating) {
                this.changeRatingError = (lang === 'es') ? 'Califica a tu profesor(a) antes de continuar.' : 'Please rate your teacher before continuing.';
                return;
            }
            this.changeRatingError = '';
            this.showSpinnerRating = true;
            let self = this;
            let json = {
                Id: 0,
                PersonTeacherId: this.teacher.id,
                Qualification: this.changeTeacherRating,
                Commentary: this.changeTeacherRatingComment || '',
                PersonStudentId: this.User.personStudentId,
                UserCreated: this.$store.state.user.email
            };
            baseInstanceAxios
                .post(`${this.API_URL}/resources/PersonsTeachers/SaveCalification`, json)
                .then(function () { self.showSpinnerRating = false; self.ratingPosted = true; })
                .catch(function () { self.showSpinnerRating = false; self.changeRatingError = (lang === 'es') ? 'No se pudo guardar la calificación. Intenta de nuevo.' : 'Could not save the rating. Please try again.'; });
        },
        // Step 2: change the teacher (only after the rating has been posted; no re-posting here).
        submitTeacherChange(){
            if (!this.ratingPosted) {
                this.changeRatingError = (lang === 'es') ? 'Primero publica la calificación.' : 'Please post the rating first.';
                return;
            }
            this.changeRatingError = '';
            this.showSpinnerChange = true;
            this.changueTeacherMethod();
        },
        changueTeacherMethod(){

            this.showSpinnerChange = true;
            let data = {
                ScheduleId: this.$store.state.user.groupScheduleStundentId,
                groupId : this.$store.state.group_id,
                Usuario : this.$store.state.user.email

            };
        
            baseInstanceAxios.get(`${this.apiURL}/resources/GroupsCoursesLessons/SaveScheduleTeacherChanges`,
            {params:data }).then(response => {
                this.$refs['modalTeacher'].hide();
                this.teacher=null;
                this.$store.state.datosSidebar.typeScheduled = 1
                this.$store.state.datosSidebar.flagEdited = true;
                this.$router.push({ path: '/horario/calendario/public'})
            
                this.showSpinnerChange = false;
                this.$bvModal.hide('modalConfirmTeacher');
                this.changeTeacherRating = null;
                this.changeTeacherRatingComment = '';

            }).catch(err =>{
                        this.showSpinnerSave = false;
                        this.message = this.$t('dashboard.modal-changue-teacher.messages');

                        this.$bvToast.show("toast-equis-modal-calendar-class");
                        this.$bvModal.hide('modalConfirmTeacher');
                        this.changeTeacherRating = null;
                        this.changeTeacherRatingComment = '';
            }) ;
            
            // this.groupsPlan= null;
        },
        showModal() {
            this.$bvModal.show("modalCalendarWeek")
            // this.$refs['modalStudentDemo'].show()
        },
        getGroupInformation() {
            baseInstanceAxios.get(`${this.apiURL}/resources/Dashboard/GetInformationGroup?GroupId=${this.$store.state.group_id}`)
                .then(response => {
                    this.groupData = response.data.entity;
                    this.$bvModal.show('modalGroupData');
                });
        },
        openLinkClassLocal(linkClass,moment,startDate,endDate){
           this.messageLinkClassResult = null;
           let result = openLinkClass(linkClass,moment,startDate,endDate,this.$store.state.user.timeZoneName);
           if(result!=""){
             this.messageLinkClassResult = result;
             this.$bvModal.show("modal-next-linkClass");
            }
        }
	}
}
</script>

<style>
.rating-gold .b-rating-star,
.rating-gold .b-rating-icon,
.rating-gold svg {
    color: #f5b301 !important;
    fill: #f5b301 !important;
}
.rating-gold {
    display: inline-flex !important;
    width: auto !important;
    padding: 0 !important;
    justify-content: flex-start !important;
    max-width: 220px;
}
.rating-gold .b-rating-star {
    flex-grow: 0 !important;
    flex-basis: auto !important;
    padding: 0 6px !important;
}
.rating-gold .b-rating-star:first-child {
    padding-left: 0 !important;
}
.change-teacher-rating-label {
    display: block;
    text-align: center;
}
.rate-teacher-btn:disabled,
.rate-teacher-btn.disabled {
    cursor: default !important;
    pointer-events: auto !important;
    background-color: #e9eaf1 !important;
    border-color: #e9eaf1 !important;
    color: #6c6f80 !important;
    opacity: 1 !important;
}
/* Keep the "My Courses" icon and the "My Teacher" avatar the same large size so both columns align */
.course-subjects-icon {
    width: 64px;
    height: 64px;
    object-fit: contain;
}
/* Teacher public rating badge (x.x ★ (n)) next to the Chat button */
.teacher-rating-badge {
    display: inline-flex;
    align-items: center;
    gap: 3px;
    font-size: 14px;
    font-weight: 700;
    color: #3d3c63;
    white-space: nowrap;
}
.teacher-rating-badge .badge-star {
    color: #f5b301;
    font-size: 15px;
}
.teacher-rating-badge .badge-count {
    font-weight: 500;
    color: #9092ab;
    font-size: 12.5px;
}
/* Slightly smaller chat icon (overrides the 20px .card-availability .btn-primary img rule) */
.card-availability .btn-primary img.chat-icon {
    width: 15px;
    height: 15px;
}
/* Even vertical spacing between the teacher name, the chat row, and the change-teacher link */
.teacher-info {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
}
/* Let both cards grow past the fixed max-height when the rating panel is shown, so they stay equal height (same bottom line) */
.card-availability.rating-open {
    max-height: none !important;
}
/* Inline rating panel (no pop-up) — lives inside the teacher card, no background */
.inline-rating {
    padding: 0;
}
.inline-rating .inline-rating-label {
    font-size: 13px;
    font-weight: 600;
    color: #3d3c63;
}
.inline-rating textarea {
    font-size: 14px;
}
/* stars top-right, transparent, a bit smaller */
.inline-rating .rating-gold {
    background: transparent !important;
    max-width: none !important;
}
.inline-rating .rating-gold .b-rating-star {
    padding: 0 2px !important;
    font-size: 0.85rem;
}
/* smaller Publish / Cancel buttons */
.inline-rating .btn-rating {
    font-size: 12px;
    padding: 3px 12px;
}
/* Issue #6 redesign: 5-star rating trigger beside the Chat button */
.rate-stars-btn {
    line-height: 1;
    white-space: nowrap;
    text-decoration: none !important;
}
.rate-stars-btn .rate-star {
    color: #f5b301;
    font-size: 22px;
    letter-spacing: 2px;
    transition: transform 0.15s ease;
}
.rate-stars-btn:hover .rate-star {
    transform: scale(1.08);
}
.rate-stars-btn.rate-stars-disabled {
    cursor: default !important;
    pointer-events: auto !important;
    opacity: 1 !important;
}
.rate-stars-btn.rate-stars-disabled .rate-star {
    color: #d5d7e0;
}
</style>
